export default {
  signIn: '\u0110\u0103ng nh\u1eadp',
  signOut: '\u0110\u0103ng xu\u1ea5t',
  points: '\u0111i\u1ec3m',
  hyattSignInButton: '\u0110\u0103ng nh\u1eadp v\u00e0o World of Hyatt',
};
